/**
 * API för förslagsformuläret (BL-169). Samma inflöde för alla ingångar:
 * POST /api/v1/feedback och POST /api/v1/feedback/{id}/attachments.
 */
import { API_URL, apiFetch } from '../../api';

const BASE = `${API_URL}/api/v1/feedback`;

async function felText(res, reserv) {
  try {
    const body = await res.json();
    return (body && typeof body.detail === 'string' && body.detail) || reserv;
  } catch {
    return reserv;
  }
}

/** Skapar förslaget och returnerar { id, status, type }. */
export async function skapaForslag(anrop) {
  const res = await apiFetch(BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(anrop),
  });
  if (!res.ok) throw new Error(await felText(res, 'Förslaget kunde inte skickas. Försök igen.'));
  return res.json();
}

/** Laddar upp en fil till ett förslag. */
export async function laddaUppFil(id, fil) {
  const form = new FormData();
  form.append('file', fil, fil.name);
  const res = await apiFetch(`${BASE}/${encodeURIComponent(id)}/attachments`, { method: 'POST', body: form });
  if (!res.ok) throw new Error(await felText(res, `${fil.name} kunde inte laddas upp.`));
  return res.json();
}

/** Egna ärenden, nyaste först (BL-377). */
export async function hamtaMinaArenden() {
  const res = await apiFetch(`${BASE}/mina`);
  if (!res.ok) throw new Error(await felText(res, 'Det gick inte att hämta dina ärenden.'));
  return res.json();
}

/** Ett eget ärende med text, bilagor och händelser (BL-377). */
export async function hamtaMittArende(ref) {
  const res = await apiFetch(`${BASE}/mina/${encodeURIComponent(ref)}`);
  if (!res.ok) throw new Error(await felText(res, 'Det gick inte att hämta ärendet.'));
  return res.json();
}

/** Eget val för mejl 3, "Arbetet har börjat" (BL-499). */
export async function hamtaMejlval() {
  const res = await apiFetch(`${BASE}/mina/mejlval`);
  if (!res.ok) throw new Error(await felText(res, 'Det gick inte att hämta mejlvalet.'));
  return res.json();
}

export async function sparaMejlval(paborjad) {
  const res = await apiFetch(`${BASE}/mina/mejlval`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ paborjad }),
  });
  if (!res.ok) throw new Error(await felText(res, 'Valet kunde inte sparas. Försök igen.'));
  return res.json();
}

/** Laddar ner en egen bilaga via den befintliga nedladdningen, som släpper fram inskickaren. */
export async function laddaNerBilaga(ref, filnamn) {
  const res = await apiFetch(`${BASE}/${encodeURIComponent(ref)}/attachments/${encodeURIComponent(filnamn)}`);
  if (!res.ok) throw new Error(await felText(res, `${filnamn} kunde inte laddas ner.`));
  const url = URL.createObjectURL(await res.blob());
  const a = document.createElement('a');
  a.href = url;
  a.download = filnamn;
  a.click();
  URL.revokeObjectURL(url);
}
